import React, { useState } from 'react'
import Card from 'transfix-ui/components/Card'
import { Typography } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Skeleton from 'transfix-ui/core/Skeleton'
import { IMotorCarrierInsuranceContact } from 'types/FMSGraphqlTypes'
import { Button, INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui'
import { AddInsuranceContactInformationModal } from './AddInsuranceContactInformationModal'
import InsuranceContactInformationRow from './InsuranceContactInformationRow'
import { useInsuranceContactsQuery } from './graphql/InsuranceContacts'

const NoInsuranceText = () => (
  <span>
    In order to haul loads, we require Automobile/BIPD and Cargo Certificate(s) of Insurance.
  </span>
)

const SkeletonLoader = () => (
  <div>
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </div>
)
interface IInsuranceContactInformationCard {
  motorCarrierId: string | undefined
}

const InsuranceContactInformationCard = ({
  motorCarrierId = '',
}: IInsuranceContactInformationCard) => {
  const [isOpen, setOpen] = useState<boolean>(false)

  const { data, error, loading, refetch } = useInsuranceContactsQuery({
    variables: {
      motorCarrierId,
    },
  })
  const { insuranceContacts = [] } = data || {}

  const hasInsurance = !!motorCarrierId && !!insuranceContacts.length

  const addHandler = () => {
    setOpen(true)
  }

  const closeHandler = () => {
    setOpen(false)
  }

  return (
    <Card>
      <Box display='grid' gap='20px'>
        <Typography variant='h3'>Insurance Contact Information</Typography>
        <Typography variant='body2'>
          Keep your insurance info up to date. {!hasInsurance && <NoInsuranceText />}
        </Typography>
        {hasInsurance && (
          <>
            {loading && <SkeletonLoader />}
            {!loading &&
              insuranceContacts.map((contact: IMotorCarrierInsuranceContact) => (
                <InsuranceContactInformationRow contact={contact} />
              ))}
            {error && (
              <InlineMessage
                type={INLINE_MESSAGE_VARIANTS.ALERT}
                message={`There was an error loading your insurance contact information. ${error?.message}`}
              />
            )}
          </>
        )}
        <div>
          <Button variant='text' onClick={addHandler}>
            Add Insurance Contact Information
          </Button>
        </div>
        <AddInsuranceContactInformationModal
          onClose={closeHandler}
          open={isOpen}
          motorCarrierId={motorCarrierId}
          refetch={refetch}
        />
      </Box>
    </Card>
  )
}

export default InsuranceContactInformationCard
